import React from 'react';
import AddIcon from '@mui/icons-material/Add';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import ArticleIcon from '@mui/icons-material/Article';
import AssignmentIcon from '@mui/icons-material/Assignment';
import BadgeIcon from '@mui/icons-material/Badge';
import BarChartIcon from '@mui/icons-material/BarChart';
import BorderStyleIcon from '@mui/icons-material/BorderStyle';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CollectionsIcon from '@mui/icons-material/Collections';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CropSquareIcon from '@mui/icons-material/CropSquare';
import DeleteIcon from '@mui/icons-material/Delete';
import DescriptionIcon from '@mui/icons-material/Description';
import DrawIcon from '@mui/icons-material/Draw';
import EditIcon from '@mui/icons-material/Edit';
import EditNoteIcon from '@mui/icons-material/EditNote';
import EmailIcon from '@mui/icons-material/Email';
import FaceIcon from '@mui/icons-material/Face';
import FacebookIcon from '@mui/icons-material/Facebook';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';
import GroupsIcon from '@mui/icons-material/Groups';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import ImageIcon from '@mui/icons-material/Image';
import IosShareIcon from '@mui/icons-material/IosShare';
import LinkIcon from '@mui/icons-material/Link';
import ListAltIcon from '@mui/icons-material/ListAlt';
import LockPersonIcon from '@mui/icons-material/LockPerson';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import MicIcon from '@mui/icons-material/Mic';
import NewspaperIcon from '@mui/icons-material/Newspaper';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import PaletteIcon from '@mui/icons-material/Palette';
import PeopleIcon from '@mui/icons-material/People';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import PieChartIcon from '@mui/icons-material/PieChart';
import PollIcon from '@mui/icons-material/Poll';
import PublicIcon from '@mui/icons-material/Public';
import RepeatIcon from '@mui/icons-material/Repeat';
import SearchIcon from '@mui/icons-material/Search';
import SellIcon from '@mui/icons-material/Sell';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import StarIcon from '@mui/icons-material/Star';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import TableChartIcon from '@mui/icons-material/TableChart';
import TheaterComedyIcon from '@mui/icons-material/TheaterComedy';
import TodayIcon from '@mui/icons-material/Today';
import UndoIcon from '@mui/icons-material/Undo';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import VideoFileIcon from '@mui/icons-material/VideoFile';
import VideoLibraryIcon from '@mui/icons-material/VideoLibrary';
import VideocamIcon from '@mui/icons-material/Videocam';
import ViewWeekIcon from '@mui/icons-material/ViewWeek';
import YouTubeIcon from '@mui/icons-material/YouTube';

/**
 * The original site used Font Awesome icons on its cards. Those are mapped to
 * the closest Material icon so the page needs no icon font / external CSS.
 */
const FA_TO_MUI = {
  'user-cog': ManageAccountsIcon,
  'user-shield': AdminPanelSettingsIcon,
  'user-friends': PeopleIcon,
  newspaper: NewspaperIcon,
  users: GroupsIcon,
  'address-card': BadgeIcon,
  'users-cog': SupervisedUserCircleIcon,
  question: HelpOutlineIcon,
  'envelope-open-text': MarkEmailReadIcon,
  'ticket-alt': ConfirmationNumberIcon,
  signature: DrawIcon,
  'chart-bar': BarChartIcon,
  'chart-line': ShowChartIcon,
  'calendar-alt': CalendarMonthIcon,
  'file-export': FileUploadIcon,
  'user-plus': PersonAddIcon,
  trash: DeleteIcon,
  'list-alt': ListAltIcon,
  'mail-bulk': EmailIcon,
  'user-tag': SellIcon,
  'user-slash': PersonOffIcon,
  'file-medical': NoteAddIcon,
  'globe-asia': PublicIcon,
  copy: ContentCopyIcon,
  'share-square': IosShareIcon,
  star: StarIcon,
  table: TableChartIcon,
  'pencil-alt': EditIcon,
  'file-download': FileDownloadIcon,
  'border-style': BorderStyleIcon,
  images: CollectionsIcon,
  undo: UndoIcon,
  'microphone-alt': MicIcon,
  'file-video': VideoFileIcon,
  video: VideocamIcon,
  youtube: YouTubeIcon,
  'vimeo-v': VideoLibraryIcon,
  'user-lock': LockPersonIcon,
  'user-edit': EditNoteIcon,
  'user-astronaut': FaceIcon,
  'file-pdf': PictureAsPdfIcon,
  'square-full': CropSquareIcon,
  palette: PaletteIcon,
  edit: EditIcon,
  'facebook-square': FacebookIcon,
  search: SearchIcon,
  link: LinkIcon,
  envelope: EmailIcon,
  'theater-masks': TheaterComedyIcon,
  'clipboard-list': AssignmentIcon,
  poll: PollIcon,
  plus: AddIcon,
  'chart-pie': PieChartIcon,
  'file-alt': DescriptionIcon,
  'quote-right': FormatQuoteIcon,
  'file-image': ImageIcon,
  'file-word': ArticleIcon,
  'file-import': UploadFileIcon,
  'user-times': PersonRemoveIcon,
  'file-contract': FactCheckIcon,
  'calendar-day': TodayIcon,
  'calendar-week': ViewWeekIcon,
  retweet: RepeatIcon,
  image: ImageIcon
};

/** Renders the Material equivalent of a Font Awesome class string such as "fas fa-user-cog". */
export const FaIcon = ({ name, ...props }) => {
  const key = (String(name || '').match(/fa-([a-z0-9-]+)\s*$/) || [])[1];
  const Icon = FA_TO_MUI[key] || DescriptionIcon;
  return <Icon {...props} />;
};

export default FaIcon;
